
const userDataList = [
  {
    userImg: require('../../assets/images/cashWheel/250e12fb0b14a6d994571c183d5eff0ff0dd5bee1e22c-1ZIZu2_fw658.webp'),
    userName: 'Meet death',
    getTime: '1 minute Ago',
    getTimeIN: '1 मिनट पहले',
    amount: '₹5000'
  },
  {
    userImg: require('../../assets/images/cashWheel/606a5fa499c65bcefc092a0a5e85fa01.webp'),
    userName: 'The whole',
    getTime: '3 minutes Ago',
    getTimeIN: '3 मिनट पहले',
    amount: '₹2000'
  },
  {
    userImg: require('../../assets/images/cashWheel/618cea1e16b539075.webp'),
    userName: 'barbarity',
    getTime: '5 minutes Ago',
    getTimeIN: '5 मिनट पहले',
    amount: '₹3500'
  },
  {
    userImg: require('../../assets/images/cashWheel/358471dbf442c539.webp'),
    userName: 'Dreamer',
    getTime: 'Just Now',
    getTimeIN: 'अभी अभी',
    amount: '₹500'
  },
  {
    userImg: require('../../assets/images/cashWheel/34559309_1400857351863_mthumb.webp'),
    userName: 'Eternity',
    getTime: 'Just Now',
    getTimeIN: 'अभी अभी',
    amount: '₹3500'
  },
  {
    userImg: require('../../assets/images/cashWheel/indian-5882625_960_720.webp'),
    userName: 'Skyblue.',
    getTime: 'Just Now',
    getTimeIN: 'अभी अभी',
    amount: '₹3000'
  },
  {
    userImg: require('../../assets/images/cashWheel/indian-5882632_1280.webp'),
    userName: 'Gentleman',
    getTime: 'Just Now',
    getTimeIN: 'अभी अभी',
    amount: '₹4500'
  },
  {
    userImg: require('../../assets/images/cashWheel/indian-man-6825180_1280.webp'),
    userName: 'Forget',
    getTime: '3 hours Ago',
    getTimeIN: '3 घंटे पहले',
    amount: '₹3500'
  },
  {
    userImg: require('../../assets/images/cashWheel/man-3803551_960_720.webp'),
    userName: 'fadedlov',
    getTime: '3 hours Ago',
    getTimeIN: '3 घंटे पहले',
    amount: '₹1500'
  },
  {
    userImg: require('../../assets/images/cashWheel/OIP1.webp'),
    userName: 'Ferry.',
    getTime: '1 day Ago',
    getTimeIN: '1 दिन पहले',
    amount: '₹2500'
  },
  {
    userImg: require('../../assets/images/cashWheel/OIP2.webp'),
    userName: 'Rose.',
    getTime: '3 minutes Ago',
    getTimeIN: '3 मिनट पहले',
    amount: '₹3500'
  },
  {
    userImg: require('../../assets/images/cashWheel/OIP3.webp'),
    userName: 'Tender.',
    getTime: '3 minutes Ago',
    getTimeIN: '3 मिनट पहले',
    amount: '₹1500'
  },
  {
    userImg: require('../../assets/images/cashWheel/OIP4.webp'),
    userName: 'Virus',
    getTime: '1 day Ago',
    getTimeIN: '1 दिन पहले',
    amount: '₹1000'
  },
  {
    userImg: require('../../assets/images/cashWheel/OIP.webp'),
    userName: 'Swilder',
    getTime: '5 minutes Ago',
    getTimeIN: '5 मिनट पहले',
    amount: '₹500'
  },
  {
    userImg: require('../../assets/images/cashWheel/pexels-amirali-beigi-231365-792326.webp'),
    userName: 'detele',
    getTime: '1 day Ago',
    getTimeIN: '1 दिन पहले',
    amount: '₹1000'
  },
  {
    userImg: require('../../assets/images/cashWheel/pexels-danxavier-1121796.webp'),
    userName: 'Initially',
    getTime: '5 minutes Ago',
    getTimeIN: '5 मिनट पहले',
    amount: '₹500'
  },
  {
    userImg: require('../../assets/images/cashWheel/pexels-danxavier-1212984.webp'),
    userName: 'Farewell',
    getTime: '3 minutes Ago',
    getTimeIN: '3 मिनट पहले',
    amount: '₹4500'
  },
  {
    userImg: require('../../assets/images/cashWheel/pexels-photo-938639.webp'),
    userName: 'Rampant',
    getTime: 'Just Now',
    getTimeIN: 'अभी अभी',
    amount: '₹500'
  },
  {
    userImg: require('../../assets/images/cashWheel/pexels-photo-1315741.webp'),
    userName: 'lie',
    getTime: '3 minutes Ago',
    getTimeIN: '3 मिनट पहले',
    amount: '₹2500'
  },
  {
    userImg: require('../../assets/images/cashWheel/pexels--rahulshah--1042140.webp'),
    userName: 'Solitude',
    getTime: '3 hours Ago',
    getTimeIN: '3 घंटे पहले',
    amount: '₹5000'
  },
  {
    userImg: require('../../assets/images/cashWheel/pexels--rahulshah--1253811.webp'),
    userName: 'figure',
    getTime: 'Just Now',
    getTimeIN: 'अभी अभी',
    amount: '₹3500'
  },
  {
    userImg: require('../../assets/images/cashWheel/pexels-shivkumarsd-1379031.webp'),
    userName: 'Chagrin',
    getTime: '1 minute Ago',
    getTimeIN: '1 मिनट पहले',
    amount: '₹500'
  },
  {
    userImg: require('../../assets/images/cashWheel/R.webp'),
    userName: 'Stranger',
    getTime: '1 minute Ago',
    getTimeIN: '1 मिनट पहले',
    amount: '₹2000'
  },
  {
    userImg: require('../../assets/images/cashWheel/v2-1978aacdede5ac706fd5fc40f23f8579_720w.webp'),
    userName: 'Meet death',
    getTime: 'Just Now',
    getTimeIN: 'अभी अभी',
    amount: '₹1500'
  }
]
export { userDataList }



// WEBPACK FOOTER //
// ./src/pages/cashWheel/userData.js